import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

export default (type: any) => {
  return createMuiTheme({
    palette: {
      type: type as 'light' | 'dark',
      primary: {
        main: '#00b6dc'
      },
      secondary: {
        main: '#f8e200'
      },
      background: background[type],
      text: {
        primary: type === 'light' ? '#363f45' : '#ddd',
        secondary: type === 'light' ? '#525e66' : '#ccc'
      },
      error: {
        main: '#df041f'
      }
    },
    transitions: {
      duration: {
        leavingScreen: 200,
        enteringScreen: 200
      }
    },
    typography: {
      useNextVariants: true
    },
    appBar: appBar[type],
    button: button[type],
    checkbox: checkbox[type],
    iconButton: iconButton[type],
    sidebar: sidebar[type],
    tertiaryColors: tertiaryColors[type],
    tableRow: tableRow[type],
    colors
  });
};

const appBar: any = {
  dark: {
    height: 48,
    background: '#3f484e',
    color: '#ddd'
  },
  light: {
    height: 48,
    background: '#f8e200',
    color: '#363f45'
  }
};

const background: any = {
  dark: {
    default: '#333333',
    paper: '#474747'
  },
  light: {
    default: '#f0f0f0',
    paper: '#ffffff'
  }
};

const button: any = {
  dark: {
    yellow: {
      background: '#f7d002',
      color: '#3c464c'
    },
    transparent: {
      background: 'transparent',
      color: '#ddd'
    },
    grey: {
      background: '#525e66',
      color: '#ddd'
    }
  },
  light: {
    yellow: {
      background: '#f7d002',
      color: '#3c464c'
    },
    transparent: {
      background: 'transparent',
      color: '#525e66'
    },

    grey: {
      background: '#525e66',
      color: '#ddd'
    }
  }
};
const tertiaryColors: any = {
  dark: {
    orange: '#ae6009',
    pink: '#9c333c',
    red: '#780211',
    grey: 'rgba(255,255,255,0.2)',
    header: 'grey'
  },
  light: {
    orange: '#f5cd79',
    pink: '#ea8685',
    red: '#e77f67',
    grey: 'rgba(0,0,0,0.1)',
    header: 'lightgrey'
  }
};

const checkbox: any = {
  dark: {
    yellow: {
      color: '#f7d002'
    }
  },
  light: {
    yellow: {
      color: '#f7d002'
    }
  }
};

const iconButton: any = {
  dark: {
    yellow: {
      background: '#f7d002',
      color: '#3c464c'
    },
    transparent: {
      background: 'transparent',
      color: '#ddd',
      borderColor: '#7d7d7d'
    },
    grey: {
      background: '#525e66',
      color: '#ddd'
    }
  },
  light: {
    yellow: {
      background: '#f7d002',
      color: '#3c464c'
    },
    transparent: {
      background: '#edeff0',
      color: '#525e66',
      borderColor: '#dcdde0'
    },
    grey: {
      background: '#525e66',
      color: '#ddd'
    }
  }
};

const sidebar: any = {
  dark: {
    width: 150,
    collapsedWidth: 35,
    activeBackground: '#b7b7b7',
    activeColor: '#000'
  },
  light: {
    width: 150,
    collapsedWidth: 35,
    activeBackground: '#525e66',
    activeColor: '#ddd'
  }
};
const tableRow: any = {
  dark: {
    backgroundColor: 'rgba(0,0,0,0.3)'
  },
  light: {
    backgroundColor: '#f9f9f9'
  }
};

const colors: any = {
  error: '#df041f',
  warning: '#f5a623',
  success: '#7ed321',
  yellow: '#f8e200',
  information: '#039be5'
};

interface ICustomTheme {
  appBar: {
    height: React.CSSProperties['height'];
    background: React.CSSProperties['background'];
    color: React.CSSProperties['color'];
  };
  button: {
    yellow: {
      background: React.CSSProperties['background'];
      color: React.CSSProperties['color'];
    };
    transparent: {
      background: React.CSSProperties['background'];
      color: React.CSSProperties['color'];
    };
    grey: {
      background: React.CSSProperties['background'];
      color: React.CSSProperties['color'];
    };
  };
  checkbox: {
    yellow: {
      color: React.CSSProperties['color'];
    };
  };
  iconButton: {
    yellow: {
      background: React.CSSProperties['background'];
      color: React.CSSProperties['color'];
    };
    transparent: {
      background: React.CSSProperties['background'];
      color: React.CSSProperties['color'];
      borderColor: React.CSSProperties['borderColor'];
    };
    grey: {
      background: React.CSSProperties['background'];
      color: React.CSSProperties['color'];
    };
  };
  sidebar: {
    width: React.CSSProperties['width'];
    activeBackground: React.CSSProperties['background'];
    activeColor: React.CSSProperties['color'];
    collapsedWidth: React.CSSProperties['width'];
  };
  tertiaryColors: {
    orange: React.CSSProperties['color'];
    pink: React.CSSProperties['color'];
    red: React.CSSProperties['color'];
    grey: React.CSSProperties['color'];
    header: React.CSSProperties['color'];
  };
  colors: {
    error: string;
    warning: string;
    success: string;
    yellow: string;
    information: string;
  };
  tableRow: {
    backgroundColor: React.CSSProperties['color'];
  };
}

/* tslint:disable */
declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme extends ICustomTheme {}
  interface ThemeOptions extends ICustomTheme {}
}
